import { ProfileDialog } from '@colonist/clientforge';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
const renderProfileDialog = mountDialogUIReactComponent(ProfileDialog);
export function showProfileDialog(props) {
    renderProfileDialog(props);
}
